import { twJoin } from 'tailwind-merge';

/** Classe del pulsante nativo che apre il menu dell'avatar: nessuno stile proprio, solo l'indicatore di focus. */
export const NAVBAR_AVATAR_BUTTON_CLASS = twJoin(
  'flex rounded-full border-0 bg-transparent p-0',
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-tag-focus-ring'
);
